module.exports = __webpack_public_path__ + "img/jieshao2.cb011758.png";